module.exports = __webpack_public_path__ + "img/download.dcdd8d32.png";